//
import ProviderModel from '@/models/Purchase/PchProvider'
import WarehouseModel from '@/models/Warehouse/WhWarehouse'
import UserModel from '@/models/General/GUser'

//
import { required } from '@/services/validations'
import DetailPurchaseOrderReceptionHeaders from './headers'

//
export default props => [
    {
        name: 'pch_provider_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemKey: 'id',
            itemText: 'alias_name',
            itemValue: 'id',
            label: 'Proveedor',
            model: ProviderModel,
            noDataText: 'Sin proveedores.',
            noObject: true,
            readonly: true,
            rules: [required],
        },
    },
    {
        name: 'pch_provider_branch_offices_address',
        type: 'text-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Sucursal',
            readonly: true,
            rules: [required],
        },
    },
    {
        name: 'g_originator_user_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemText: 'full_name',
            itemValue: 'id',
            label: 'Responsable',
            model: UserModel,
            noDataText: 'Sin usuarios.',
            noObject: true,
            readonly: true,
            rules: [required],
        },
    },
    {
        name: 'pch_purchase_order_state_name',
        type: 'text-field',
        flex: {
            sm3: true,
            xs12: true,
        },
        props: {
            label: 'Estado',
            readonly: true,
        },
    },
    {
        name: 'invoice_numbers',
        type: 'combobox',
        flex: {
            sm6: true,
            lg6: true,
        },
        props: {
            chips: true,
            deletableChips: true,
            label: 'Facturas',
            multiple: true,
            rules: [required],
        },
    },
    {
        name: 'wh_warehouse_reception_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemText: 'name',
            itemValue: 'id',
            label: 'Bodega',
            model: WarehouseModel,
            noDataText: 'Sin bodegas.',
            noObject: true,
            paramFilter: {
                g_branch_office_id: props.g_branch_office_id,
            },
            rules: [required],
        },
    },
    {
        name: 'created_at',
        type: 'date-field',
        flex: {
            sm3: true,
            xs12: true,
        },
        props: {
            label: 'Creado',
            readonly: true,
        },
    },
    {
        name: 'pch_detail_purchase_orders',
        type: 'table-field',
        flex: {
            'pt-0': true,
            'd-grid': true,
            'xs12': true,
        },
        props: {
            checkable: true,
            headers: DetailPurchaseOrderReceptionHeaders(props),
            noDataText: 'Sin productos.',
            toolbarTitle: 'Lista de productos incluidos en la orden',
            rules: [required],
        },
    },
    {
        name: 'reception_comment',
        type: 'textarea',
        flex: {
            xs12: true,
        },
        props: {
            label: 'Comentario de recepción',
        },
    },
]
